<div class="w-full col-12 md:col-3 pb-2">
  <div *ngIf="availability === 'no-queue'" class="queue-unavailable pb-2">
    {{ NO_QUEUE_MESSAGE }}
  </div>

  <p-dropdown
    *ngIf="availability !== 'no-queue'"
    [placeholder]="availability === 'no-io' ? NO_IO_MESSAGE : 'Select Process'"
    [emptyMessage]="availability === 'no-io' ? NO_IO_MESSAGE : 'No results found'"
    [styleClass]="availability === 'no-io' ? 'io-unavailable' : ''"
    [panelStyleClass]="availability === 'no-io' ? 'io-unavailable-panel' : ''"
    class="pb-2"
    [options]="getAvailableGroups()"
    [group]="true"
    optionGroupLabel="label"
    optionGroupChildren="items"
    (onChange)="onProcessSelect($event)"
    [(ngModel)]="selectedType"
    [disabled]="disableProcess"
    [scrollHeight]="'500px'"
    appendTo="body"
  >
    <ng-template pTemplate="selectedItem">
      <div *ngIf="selectedType">
        <div>{{ selectedType.name }}</div>
      </div>
    </ng-template>

    <ng-template let-group pTemplate="group">
      <span class="group-header">
        <img *ngIf="group.icon.endsWith('.svg')" [src]="group.icon" class="group-header-svg-icon" />
        <i *ngIf="!group.icon.endsWith('.svg')" class="pi {{ group.icon }} group-header-icon"></i>
        {{ group.label }}
      </span>
    </ng-template>

    <ng-template let-process pTemplate="item">
      <span class="tool-item" [pTooltip]="process.desc" 
					tooltipPosition="right" 
					tooltipStyleClass="tool-desc-tooltip">
        <i class="pi {{ process.icon }} tool-item-icon"></i>
        {{ process.name }}
      </span>
    </ng-template>
  </p-dropdown>

  <div class="process flex flex-column">
    <ng-container [ngSwitch]="true">
      <div class="flex flex-column p-2">
        <div *ngSwitchCase="getType(selectedType) === ProcessType.CROP">
          <segmentation></segmentation>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.CONVERT">
          <convert></convert>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.HTQUANT">
          <htquant></htquant>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.ALIGNMENT">
          <sift></sift>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.EDOF">
          <edof></edof>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.KIDNEY">
          <kidney-classifier></kidney-classifier>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.DECONVOLUTION">
          <deconvolution></deconvolution>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.RETINAL_LAYER">
          <retinal-layer></retinal-layer>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.YOLOSEGDETECT">
          <yolosegdetect></yolosegdetect>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.CELLPOSE">
          <cellpose></cellpose>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.SCRIPT_QUPATH">
          <qupath-script></qupath-script>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.SCRIPT_IMAGEJ">
          <imagej-macro></imagej-macro>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.STAIN_ADAPTER">
          <stain-adapter></stain-adapter>
        </div>
        <div *ngSwitchCase="getType(selectedType) === ProcessType.CVAI">
          <image-processing></image-processing>
        </div>
      </div>
    </ng-container>
  </div>

</div>

